import React from 'react'


export default function ComingSoon() {
  return (
    <div className='mt-[20px] mb-[10px] item-center justify-center'>
            <div >
            <span className= 'shadow-sm animate-pulse  w-2 h-2 rounded-lg  text-black font-bold mb-10  text-[35px] ' id="comming">COMING SOON...</span>
            </div>
            
        </div>
  )
}

